import { render, staticRenderFns } from "./LmEditSecretariosSecretarias.vue?vue&type=template&id=20cfc238&scoped=true"
import script from "./LmEditSecretariosSecretarias.vue?vue&type=script&lang=js"
export * from "./LmEditSecretariosSecretarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cfc238",
  null
  
)

export default component.exports